import z from "zod";

import { TOOLBAR_ALIGNS } from "./constants";

// Absent -> true (a Toolbar is almost always followed by more content, e.g. a DataTable).
const booleanAttributeDefaultTrue = z
  .string()
  .optional()
  .transform((value) => value === undefined || value !== "false");

export const toolbarDataSchema = z.object({
  divider: booleanAttributeDefaultTrue,
  align: z.enum(TOOLBAR_ALIGNS).optional(),
  wrap: booleanAttributeDefaultTrue,
  size: z
    .enum(["sm", "md"])
    .optional()
    .describe(
      "Padding and gap; `sm` for a toolbar packed with small controls.",
    ),
});

export type ToolbarDataProps = z.infer<typeof toolbarDataSchema>;

export const toolbarSectionDataSchema = z.object({});

export type ToolbarSectionDataProps = z.infer<typeof toolbarSectionDataSchema>;
